import { render, staticRenderFns } from "./add-card.vue?vue&type=template&id=32bda5e4&scoped=true"
import script from "./add-card.vue?vue&type=script&lang=ts"
export * from "./add-card.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32bda5e4",
  null
  
)

export default component.exports